<template>
  <div
    style="
      margin: -20px -30px -30px -30px;
      padding: 20px 30px 30px;
      background: #f6f7f8;
    "
  >
    <!-- 标题 -->
    <div
      class="page-title"
      style="margin-bottom: 15px; margin: 0 auto 15px; width: 1260px"
    >
      {{ page_title }}本地图文模板
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        margin: 0 auto 15px;
        width: 1260px;
      "
    >
      <div class="screen-box">
        <!-- <div class="screen-label" style="font-size: 16px;">模板标题</div> -->
        <a-input
          v-model="r_name"
          @blur="nameBlur"
          allowClear
          placeholder="请输入模板标题"
          style="width: 370px"
        />
      </div>
      <!-- 选择书城 -->
      <div class="screen-box" style="">
        <a-select
          show-search
          style="width: 370px; height: 32px"
          placeholder="请选择书城"
          @change="handleChangeF"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          allowClear
          :value="r_channel_id"
        >
          <a-select-option
            v-for="(value, key) in bookObj"
            :key="key"
            :value="key"
          >
            {{ value.channel_name }}
          </a-select-option>
        </a-select>
      </div>
      <!-- 模式 -->
      <div class="screen-box" style="">
        <a-select
          show-search
          style="width: 370px; height: 32px"
          placeholder="请选择模式"
          :getPopupContainer="getsPopupContainer"
          allowClear
          v-model="r_type"
        >
          <a-select-option :value="1"> H5 </a-select-option>
          <a-select-option :value="2" v-if="calcIsLedu">
            H5+小程序
          </a-select-option>
          <a-select-option :value="3" v-if="calcIsLedu">
            小程序
          </a-select-option>
          <!-- <a-select-option :value="0"> 未知 </a-select-option> -->
        </a-select>
      </div>
    </div>
    <div
      style="
        display: flex;
        justify-content: space-between;
        width: 1260px;
        margin: 0 auto;
      "
    >
      <!-- 左侧内容 -->
      <div style="">
        <div class="left-box box-radius">
          <div
            @click="changeMaterial(item, index)"
            v-for="(item, index) in contentData"
            :key="item.for_id"
          >
            <!-- 第一个素材-大图显示 -->
            <div
              v-if="index == 0"
              @click="changeMaterial(contentData[0], 0)"
              class="left-cell-top"
              :class="[contentData[0].select_status ? 'left-box-border' : '']"
            >
              <img
                v-if="contentData[0].message_cover"
                style="width: 100%; height: 150px"
                :src="contentData[0].message_cover"
                alt=""
              />
              <div
                v-else
                style="width: 100%; height: 150px; border: 1px solid #ccc"
              ></div>
              <div class="left-top-title">
                {{ contentData[0].message_title || "标题" }}
              </div>
              <!-- hover操作 -->
              <div class="left-cell-operation">
                <div style="">
                  <a-icon type="arrow-up" class="left-cell-operation-icon" />
                  <a-icon
                    @click.stop="sortIconButton(2, 0)"
                    type="arrow-down"
                    class="left-cell-operation-icon"
                    style="margin-left: 5px"
                  />
                </div>
                <a-popconfirm
                  title="确定删除此篇图文?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirmDelImg(0)"
                  @cancel="cancelDelImg"
                >
                  <a-icon
                    @click.stop="sortIconButton(3, 0)"
                    type="delete"
                    class="left-cell-operation-icon"
                  />
                </a-popconfirm>
              </div>
            </div>
            <!-- 第一个后面的素材 -->
            <div
              v-if="index > 0"
              class="left-cell-box"
              :class="[
                item.select_status ? 'left-box-border' : 'left-cell-box-boder',
              ]"
            >
              <div style="flex: 1">{{ item.message_title || "标题" }}</div>
              <img
                v-if="item.message_cover"
                class="left-cell-img"
                :src="item.message_cover"
                alt=""
              />
              <div
                v-else
                class="left-cell-img"
                style="border: 1px solid #ccc"
              ></div>

              <!-- hover操作 -->
              <div class="left-cell-operation">
                <div style="">
                  <a-icon
                    @click.stop="sortIconButton(1, index)"
                    type="arrow-up"
                    class="left-cell-operation-icon"
                  />
                  <a-icon
                    @click.stop="sortIconButton(2, index)"
                    type="arrow-down"
                    class="left-cell-operation-icon"
                    style="margin-left: 7px"
                  />
                </div>
                <a-popconfirm
                  title="确定删除此篇图文?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirmDelImg(index)"
                  @cancel="cancelDelImg"
                >
                  <a-icon
                    @click.stop="sortIconButton(3, index)"
                    type="delete"
                    class="left-cell-operation-icon"
                  />
                </a-popconfirm>
              </div>
            </div>
          </div>

          <div @click="addContent" class="left-cell-add" style="">
            + 新建素材
          </div>
        </div>
      </div>

      <!-- 中间内容，包括标题、富文本 -->
      <div style="width: 628px; margin: 0 30px">
        <div
          style="padding: 30px 35px; background-color: #fff"
          class="box-radius"
        >
          <div id="title-select-mousedown" style="position: relative">
            <a-input
              v-model="contentData[content_index].message_title"
              size="large"
              placeholder="文章标题"
              style="width: 100%"
            />

            <div v-show="title_select_control" class="title-select-box">
              <div
                @click="selectTitleCell(item)"
                class="title-select-cell"
                v-for="(item, index) in titleSelectData"
                :key="index"
              >
                {{ item.content }}
              </div>
            </div>
          </div>

          <a-input
            v-model="contentData[content_index].message_auth"
            placeholder="作者，选填，默认为公众号名称"
            style="width: 100%; margin-top: 20px"
          />

          <!-- 富文本 -->
          <div
            style="
              width: 100%;
              margin-top: 20px;
              position: relative;
              height: 836px;
            "
          >
            <div style="" class="editor-box">
              <a-button v-if="channel_parent == '乐读'" @click="editorButton(1)"
                >插入链接</a-button
              >
              <!-- <a-button @click="editorButton(2)">插入小程序</a-button> -->
              <Editor
                id="tinymce"
                v-model="contentData[content_index].message_content"
                :init="init"
              ></Editor>
            </div>
          </div>
          <div
            style="
              text-align: center;
              margin-bottom: 6px;
              color: #999;
              margin-top: 6px;
            "
          >
            正文底部区域
          </div>
          <!-- H5 -->
          <div v-if="calcShowH5">
            <p style="font-weight: bold">跳转到H5，使用下面设置</p>
            <div style="margin: 30px 0 30px; border: 1px dashed #d9d9d9">
              <div style="cursor: pointer" @click="selectImg(2)">
                <img
                  v-if="contentData[content_index].message_show_foot_img"
                  :src="contentData[content_index].message_show_foot_img"
                  style="width: 100%; height: 130px; object-fit: contain"
                  alt=""
                />
                <div
                  v-else
                  style="
                    height: 130px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #999;
                  "
                >
                  二维码底图 -- 点击添加 / 更换
                </div>
              </div>
            </div>
            <div style="margin: 30px 0 30px; border: 1px dashed #d9d9d9">
              <div style="cursor: pointer" @click="selectImg(3)">
                <img
                  v-if="contentData[content_index].message_continue_read"
                  :src="contentData[content_index].message_continue_read"
                  style="width: 100%; height: 130px; object-fit: contain"
                  alt="阅读原文提示"
                />
                <div
                  v-else
                  style="
                    height: 130px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #999;
                  "
                >
                  阅读原文提示图片 -- 点击添加 / 更换
                </div>
              </div>
            </div>
          </div>
          <!-- 小程序 -->
          <div v-if="calcShowMiniCard">
            <p style="font-weight: bold">跳转到小程序，使用下面设置</p>
            <!--  -->
            <div class="mini_div">
              <div class="mini_box">
                <a-input
                  v-model="contentData[content_index].miniprogram_title"
                  @blur="titleInputBlur"
                  @change="titleInputChange"
                  @focus="titleInputFocus"
                  size="middle"
                  placeholder="小程序标题"
                  style="width: 240px"
                />
                <div @click="selectImg(4)" class="xcx_image_div">
                  <div
                    class="cut_div_box"
                    v-if="contentData[content_index].miniprogram_imageurl"
                  >
                    <div class="cut_div">
                      <div
                        class="cut_content_div"
                        @click.stop="
                          cutClick(
                            contentData[content_index].miniprogram_imageurl
                          )
                        "
                      >
                        <!--  -->
                        <a-icon style="font-size: 18px" type="scissor" />
                        <div>裁剪封面</div>
                      </div>
                      <div class="cut_content_div">
                        <a-icon style="font-size: 18px" type="swap" />
                        <div>更换封面</div>
                      </div>
                    </div>
                  </div>

                  <img
                    v-if="contentData[content_index].miniprogram_imageurl"
                    :src="contentData[content_index].miniprogram_imageurl"
                    style="height: 180px; object-fit: cover"
                    alt="小程序卡片封面图"
                  />

                  <div
                    v-else
                    style="
                      height: 130px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      color: #999;
                    "
                  >
                    小程序卡片封面图 -- 点击添加 / 更换，图片必须为1080*864px
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="position: sticky; bottom: 0; z-index: 99">
          <div
            style="width: 100%; height: 13px; background-color: #f6f7f8"
          ></div>
          <div
            class="form-cell-box box-radius"
            style="padding: 20px 30px; background-color: #fff"
          >
            <a-button
              @click="addRequest"
              type="primary"
              style="margin-right: 20px"
              >确认</a-button
            >
            <a-button @click="cancelButton">取消</a-button>
          </div>
        </div>
      </div>

      <!-- 右侧内容 -->
      <div style="width: 300px; flex-shrink: 0">
        <div style="">
          <div
            style="padding: 20px 25px; background-color: #fff"
            class="box-radius"
          >
            <div style="font-size: 16px; font-weight: 600; margin-bottom: 15px">
              设置 二维码 与 原文链接
            </div>
            <div>二维码 与 原文链接 添加方式：</div>
            <div style="margin: 7px 0 20px 0">
              <a-radio-group
                @change="radioChangeA"
                name="radioGroup"
                :value="1"
              >
                <a-radio :value="1"> 自动生成 </a-radio>
              </a-radio-group>
            </div>

            <a-input
              v-model="contentData[content_index].spread_name"
              allowClear
              placeholder="推广链接名称"
              style="width: 100%; margin-bottom: 20px"
            />

            <a-radio-group
              @change="radioChangeB"
              name="radioGroup"
              style="margin-bottom: 20px"
              :value="contentData[content_index].spread_type"
            >
              <a-radio :value="1"> 内推链接 </a-radio>
              <a-radio :value="0"> 外推链接 </a-radio>
            </a-radio-group>
            <div style="margin-bottom: 20px">
              <a-select
                style="width: 100%"
                placeholder="阅读类型"
                @change="handleChangeB"
                :filter-option="filterOption"
                :getPopupContainer="getsPopupContainer"
                :value="contentData[content_index].read_type"
              >
                <template v-if="readTypePlus">
                  <a-select-option
                    v-for="item in readTypeOptions"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.label }}
                  </a-select-option>
                </template>
                <a-select-option v-else :value="1">
                  继续阅读某本书
                </a-select-option>
                <!-- <a-select-option :value="2">
							  阅读记录页面
							</a-select-option> -->
              </a-select>
            </div>

            <template v-if="contentData[content_index].read_type === 1">
              <template v-if="!r_channel_id">
                <div
                  style="margin-bottom: 7px; display: flex; align-items: center"
                >
                  <div>设置作品信息：</div>
                </div>
                <div>请先选择书城，方可设置作品信息</div>
              </template>

              <template v-else-if="r_channel_id && !channel_parent">
                <div
                  style="margin-bottom: 7px; display: flex; align-items: center"
                >
                  <div>设置作品信息：</div>
                </div>
                <div @click="goPage(1)" style="cursor: pointer">
                  没有父类渠道，点击前往设置
                </div>
              </template>

              <template v-else-if="r_channel_id && channel_parent">
                <div
                  style="margin-bottom: 7px; display: flex; align-items: center"
                >
                  <div>设置作品信息：</div>
                  <a-button
                    v-if="
                      channel_parent.indexOf('文鼎') > -1 ||
                      channel_parent.indexOf('迈步') > -1 ||
                      channel_parent.indexOf('阳光') > -1 ||
                      channel_parent.indexOf('阅文') > -1 ||
                      channel_parent.indexOf('掌中') > -1
                    "
                    size="small"
                    @click="resolveUrl"
                    type="primary"
                    >解析推广链接</a-button
                  >
                </div>

                <!-- 迈步和掌中云，不用填作品ID，默认传0 -->
                <a-input
                  v-if="
                    channel_parent == '乐读' ||
                    channel_parent == '常读' ||
                    channel_parent == '掌读' ||
                    channel_parent == '追书云' ||
                    channel_parent == '文鼎' ||
                    channel_parent == '万读' ||
                    channel_parent.indexOf('迈步') > -1 ||
                    channel_parent.indexOf('阳光') > -1 ||
                    channel_parent.indexOf('阅文') > -1 ||
                    channel_parent.indexOf('花生') > -1
                  "
                  v-model="contentData[content_index].spread_book_id"
                  allowClear
                  placeholder="请填写作品ID"
                  style="width: 100%; margin-bottom: 20px"
                />

                <a-input
                  v-if="
                    channel_parent == '乐读' ||
                    channel_parent == '常读' ||
                    channel_parent == '掌读' ||
                    channel_parent == '追书云' ||
                    channel_parent == '万读' ||
                    channel_parent.indexOf('阳光') > -1
                  "
                  v-model="contentData[content_index].spread_chapter_id"
                  allowClear
                  placeholder="输入章节序号"
                  style="width: 100%"
                />

                <a-input
                  v-else-if="
                    channel_parent == '文鼎' ||
                    channel_parent.indexOf('迈步') > -1 ||
                    channel_parent.indexOf('阅文') > -1 ||
                    channel_parent.indexOf('掌中') > -1 ||
                    channel_parent.indexOf('花生') > -1
                  "
                  v-model="contentData[content_index].spread_chapter_id"
                  allowClear
                  placeholder="输入章节ID"
                  style="width: 100%"
                />
              </template>
            </template>
          </div>

          <div
            style="width: 100%; height: 20px; background-color: #f6f7f8"
          ></div>

          <div
            style="padding: 20px 25px; background-color: #fff"
            class="box-radius"
          >
            <div style="display: flex; align-items: center">
              <div
                style="margin-right: 30px; font-size: 16px; font-weight: 600"
              >
                设置封面
              </div>
            </div>

            <div class="cover-box">
              <img
                v-if="contentData[content_index].message_cover"
                :src="contentData[content_index].message_cover"
                style="width: 100%; height: 150px; object-fit: contain"
                alt=""
              />
              <div
                @click="selectImg(1)"
                v-else
                style="
                  height: 150px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #999;
                  cursor: pointer;
                "
              >
                图片展示区域
              </div>

              <div
                v-if="contentData[content_index].message_cover"
                class="cover-handle"
              >
                <div
                  @click="cutCover"
                  style="color: #fff; text-align: center; cursor: pointer"
                >
                  <a-icon style="font-size: 18px" type="scissor" />
                  <div>裁剪封面</div>
                </div>
                <div
                  @click="selectImg(1)"
                  style="color: #fff; text-align: center; cursor: pointer"
                >
                  <a-icon style="font-size: 18px" type="swap" />
                  <div>更换封面</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a-modal
      title="图库"
      :visible="img_visible"
      :confirm-loading="img_confirmLoading"
      @ok="imgHandleOk"
      @cancel="imgHandleCancel"
      width="1100px"
    >
      <div style="position: relative; margin: -24px; padding: 24px">
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <a-tabs :activeKey="img_type" @change="imgCallback" style="flex: 1">
            <a-tab-pane :key="1" tab="封面图"></a-tab-pane>
            <a-tab-pane :key="2" tab="二维码的背景图"></a-tab-pane>
            <a-tab-pane :key="3" tab="阅读原文提示图"></a-tab-pane>
            <a-tab-pane
              :key="4"
              tab="小程序封面图"
              v-if="calcIsLedu"
            ></a-tab-pane>
          </a-tabs>

          <a-upload
            v-show="img_type == 1"
            accept="image/*"
            name="file"
            class="avatar-uploader"
            :show-upload-list="false"
            :action="`${$http.excel_url}api/common/upload-image`"
            :data="{
              name: 'Image.png',
              type: 4,
              material_type: 2, // 2=封面图，4=继续阅读底图，5=文章顶图
            }"
            :headers="{
              Authorization: headers_token,
            }"
            :withCredentials="true"
            method="post"
            :before-upload="beforeUpload"
            @change="uploadChange"
          >
            <a-button type="primary" style="margin-left: 30px">
              <a-icon type="upload" />本地上传
            </a-button>
          </a-upload>

          <a-upload
            v-show="img_type == 3"
            accept="image/*"
            name="file"
            class="avatar-uploader"
            :show-upload-list="false"
            :action="`${$http.excel_url}api/common/upload-image`"
            :data="{
              name: 'Image.png',
              type: 4,
              material_type: 4, // 2=封面图，4=继续阅读底图，5=文章顶图
            }"
            :headers="{
              Authorization: headers_token,
            }"
            :withCredentials="true"
            method="post"
            :before-upload="beforeUpload"
            @change="uploadChange"
          >
            <a-button type="primary" style="margin-left: 30px">
              <a-icon type="upload" />本地上传
            </a-button>
          </a-upload>
          <!--小程序封面图  -->
          <a-upload
            v-show="img_type == 4"
            accept="image/*"
            name="file"
            class="avatar-uploader"
            :show-upload-list="false"
            :action="`${$http.excel_url}api/common/upload-image`"
            :data="{
              name: 'Image.png',
              type: 4,
              material_type: 6, // 2=封面图，4=继续阅读底图，5=文章顶图 6小程序封面图
            }"
            :headers="{
              Authorization: headers_token,
            }"
            :withCredentials="true"
            method="post"
            :before-upload="beforeUpload"
            @change="uploadChange"
          >
            <a-button type="primary" style="margin-left: 30px">
              <a-icon type="upload" />本地上传
            </a-button>
          </a-upload>
        </div>
        <div v-show="img_type == 1">
          <!-- 选择封面 -->
          <img
            v-for="(item, index) in fmImgData"
            @click="clickFmImg(index)"
            :class="[item.select_img ? 'select_img-border' : '']"
            style="
              width: 330px;
              height: 130px;
              margin: 0 20px 15px 0;
              cursor: pointer;
              object-fit: contain;
              border: 1px solid #eee;
            "
            :key="item.content"
            :src="item.content"
            alt=""
          />
          <!-- 内容为空提示 -->
          <div class="img-content-null" v-show="fmImgData.length == 0">
            <a-icon style="font-size: 70px; color: #999" type="file-search" />
            <div class="img-content-null-text">内容为空</div>
          </div>
        </div>
        <div v-show="img_type == 2">
          <!-- 二维码图片 -->
          <img
            v-for="(item, index) in ewmImgData"
            @click="clickEwmImg(index)"
            :class="[item.select_img ? 'select_img-border' : '']"
            style="
              width: 330px;
              height: 115px;
              margin: 0 20px 15px 0;
              cursor: pointer;
            "
            :key="item.content"
            :src="item.content"
            alt=""
          />
          <!-- 内容为空提示 -->
          <div class="img-content-null" v-show="ewmImgData.length == 0">
            <a-icon style="font-size: 70px; color: #999" type="file-search" />
            <div class="img-content-null-text">内容为空</div>
          </div>
        </div>
        <div v-show="img_type == 3">
          <!-- 阅读原文提示图 -->
          <img
            v-for="(item, index) in ydywData"
            @click="clickYdywImg(index)"
            :class="[item.select_img ? 'select_img-border' : '']"
            style="
              width: 330px;
              height: 130px;
              margin: 0 20px 15px 0;
              cursor: pointer;
              object-fit: contain;
              border: 1px solid #eee;
            "
            :key="item.content"
            :src="item.content"
            alt=""
          />
          <!-- 内容为空提示 -->
          <div class="img-content-null" v-show="ydywData.length == 0">
            <a-icon style="font-size: 70px; color: #999" type="file-search" />
            <div class="img-content-null-text">内容为空</div>
          </div>
        </div>
        <div v-show="img_type == 4">
          <!-- 阅读原文提示图 -->
          <img
            v-for="(item, index) in xcmfmData"
            @click="clickXcxfmImg(index)"
            :class="[item.select_img ? 'select_img-border' : '']"
            style="
              width: 330px;
              height: 130px;
              margin: 0 20px 15px 0;
              cursor: pointer;
              object-fit: contain;
              border: 1px solid #eee;
            "
            :key="item.content"
            :src="item.content"
            alt=""
          />
          <!-- 内容为空提示 -->
          <div class="img-content-null" v-show="xcmfmData.length == 0">
            <a-icon style="font-size: 70px; color: #999" type="file-search" />
            <div class="img-content-null-text">内容为空</div>
          </div>
        </div>
        <a-pagination
          v-model="img_page"
          :pageSize="img_limit"
          :total="show_img_total"
          @change="imgPagingChange"
          :showTotal="(total, range) => `共 ${total} 条`"
          show-quick-jumper
          style="text-align: center; margin-top: 15px"
        />

        <div class="img_loading" v-show="img_search_loading">
          <a-spin size="large" />
        </div>
      </div>
    </a-modal>

    <a-modal
      title="解析推广链接"
      :visible="url_visible"
      :confirm-loading="url_confirmLoading"
      @ok="urlHandleOk"
      @cancel="urlHandleCancel"
      width="700px"
      okText="解析"
    >
      <div>
        <a-textarea
          v-model="r_url"
          placeholder="请输入推广链接，用于解析"
          :auto-size="{ minRows: 3, maxRows: 10 }"
        />
      </div>
    </a-modal>

    <a-modal
      title="裁切图片"
      :visible="cut_visible"
      :confirm-loading="cut_confirmLoading"
      @ok="cutHandleOk"
      @cancel="cutHandleCancel"
      width="700px"
      okText="确认"
    >
      <div
        :style="{ width: cropper_width + 'px', height: cropper_height + 'px' }"
        style="margin: auto"
      >
        <vueCropper
          ref="cropper"
          :img="cor_option.img"
          :outputSize="cor_option.size"
          :outputType="cor_option.outputType"
          :canScale="false"
          :info="true"
          :full="cor_option.full"
          :fixed="fixed"
          :fixed-number="fixedNumber"
          :can-move="cor_option.canMove"
          :can-move-box="cor_option.canMoveBox"
          :fixed-box="cor_option.fixedBox"
          :original="cor_option.original"
          :auto-crop="cor_option.autoCrop"
          :auto-crop-width="cor_option.autoCropWidth"
          :auto-crop-height="cor_option.autoCropHeight"
          :center-box="cor_option.centerBox"
        ></vueCropper>
      </div>
    </a-modal>

    <!-- 插入链接 弹窗 -->
    <InsertLink
      ref="getInsertLink"
      @insert-link="insertLinkHandle"
    ></InsertLink>
    <!-- 插入小程序弹窗 -->
    <!-- <xcxLink ref="getXcxLink" @modal-ok="xcxModalOk"></xcxLink> -->

    <!-- 加载中 -->
    <div class="loading-box" v-show="search_button_loading">
      <a-spin size="large" />
    </div>

    <CutImage ref="getCropperImg" @cropper-ok="cropperOk" />
  </div>
</template>

<script>
import tinymce from "tinymce";
import "tinymce/themes/silver";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/icons/default/icons";

import "tinymce/themes/silver/theme";
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/paste";

import {
  landAddUploadImage,
  materialLocalMessage,
  materialAdd,
  materialInfo,
  materialEdit,
  materialCodeUrl,
  materialSelectChannel,
} from "@/request/api";
import { VueCropper } from "vue-cropper";
import CutImage from "./components/cutImage.vue";

import InsertLink from "@/views/Operate/operMessage/components/InsertLink.vue";
import xcxLink from "@/views/Operate/operMessage/components/xcxLink.vue";
let _this = undefined;
export default {
  name: "materialAdd_",
  components: { Editor, VueCropper, InsertLink, xcxLink, CutImage },
  data() {
    return {
      r_type: 1,
      readTypeOptions: [
        { label: "继续阅读某本书", value: 1 },
        { label: "历史记录/最近阅读作品", value: 2 },
        { label: "书架/阅读历史列表", value: 3 },
        { label: "签到", value: 4 },
        { label: "充值", value: 5 },
        { label: "个人中心", value: 6 },
        { label: "联系客服", value: 7 },
        { label: "首页-男频", value: 8 },
        { label: "首页-女频", value: 9 },
        { label: "排行榜", value: 10 },
      ],
      // 富文本开始
      value: "",
      contenyt: {},
      init: {
        language_url: "/zh_CN.js", // 语言包位置，因为放在public下所以可以省略public
        selector: "#tinymce", //tinymce的id
        language: "zh_CN", //语言类型
        skin_url: "/skins/ui/oxide",
        height: 800, //编辑器高度
        branding: false, //是否禁用 branding水印
        // forced_root_block: false, // 强制根节点块元素
        content_style:
          "img,section {max-width:100% !important;} a{text-decoration: auto;}",
        // content_style: "img,section {max-width:100% !important;background-size: auto !important;}",
        // browser_spellcheck: true, // 拼写检查
        // elementpath: false, //禁用编辑器底部的状态栏
        // statusbar: false, // 隐藏编辑器底部的状态栏
        paste_data_images: true, // 允许粘贴图像
        image_dimensions: false, // 取消图片上传时输入宽高，避免图片无法自适应
        // menubar: false, //最顶部文字信息
        plugins: "image link code lists wordcount",
        // branding: false, //是否禁用“Powered by TinyMCE”
        toolbar:
          "fontselect fontsizeselect styleselect lineheight | link lineheight forecolor backcolor bold italic underline | alignleft aligncenter alignright alignjustify | image quicklink h2 h3 blockquote table numlist bullist preview fullscreen", //工具栏
        fontsize_formats:
          "12px 14px 15px 16px 18px 20px 24px 26px 28px 30px 32px 34px 36px 40px 48px 52px 56px 72px",
        lineheight_formats: "1 1.2 1.5 1.6 1.8 2 2.4",
        font_formats:
          "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;",
        extended_valid_elements:
          "span[style|class|box-sizing|-webkit-tap-highlight-color|display|font-size|background-image|margin-left|margin-right|background-size|background-repeat|background-position|visibility|class|src|alt|title|hspace|vspace|width|height|align|onmouseover|onmouseout|name|background|overflow-wrap|max-width|padding],p[style|class|margin|padding|max-width|clear|min-height|text-indent|box-sizing|overflow-wrap|font-size|line-height|text-align|width|align],section[style|class|background-image|background-repeat|background-size|background-position|padding|box-sizing|background],br[style|class]",

        style_formats: [
          {
            title: "行高",
            items: [
              { title: "1", block: "p", styles: { "line-height": "1.0" } },
              { title: "1.5", block: "p", styles: { "line-height": "1.5" } },
              { title: "1.6", block: "p", styles: { "line-height": "1.6" } },
              { title: "1.7", block: "p", styles: { "line-height": "1.7" } },
              { title: "1.8", block: "p", styles: { "line-height": "1.8" } },
              { title: "1.9", block: "p", styles: { "line-height": "1.9" } },
              { title: "2", block: "p", styles: { "line-height": "2" } },
              { title: "2.1", block: "p", styles: { "line-height": "2.1" } },
              { title: "2.2", block: "p", styles: { "line-height": "2.2" } },
              { title: "2.3", block: "p", styles: { "line-height": "2.3" } },
              { title: "2.4", block: "p", styles: { "line-height": "2.4" } },
              { title: "2.5", block: "p", styles: { "line-height": "2.5" } },
              { title: "2.6", block: "p", styles: { "line-height": "2.6" } },
              { title: "2.7", block: "p", styles: { "line-height": "2.7" } },
              { title: "2.8", block: "p", styles: { "line-height": "2.8" } },
              { title: "2.9", block: "p", styles: { "line-height": "2.9" } },
              { title: "3", block: "p", styles: { "line-height": "3" } },
              { title: "3.5", block: "p", styles: { "line-height": "3.5" } },
              { title: "4", block: "p", styles: { "line-height": "4" } },
              { title: "5", block: "p", styles: { "line-height": "5" } },
            ],
          },
        ],
        // 如果不设置这个的话，对替换掉原来已有的，就只剩下个行高了。所以要附加而不是替换
        style_formats_merge: true, //是否将style_formats设置中的样式附加到默认样式格式还是完全替换它们。true为附加
        // style_formats_autohide: true, //隐藏当前不可用的样式列表

        images_upload_handler: function (blobInfo, succFun, failFun) {
          var file = blobInfo.blob(); //转化为易于理解的file对象

          var params = new FormData();
          params.append("file", file);
          params.append("type", 5);

          // file 即选中的文件
          // 自己实现上传，并得到图片 url alt href
          landAddUploadImage(params).then((res) => {
            if (res.data.code == 401) {
              // 未登录
              // this.$message.error(`错误：${res.data.msg || "未登录"}`);
              alert(`错误：${res.data.msg || "未登录"}`);
            }

            // 最后插入图片。这里传入图片链接就可以
            succFun(res.data.data.url);
          });
        },

        // 引入powerpaste 注册   改plugins配置中的 paste为powerpaste
        // 		external_plugins: {

        // 		  powerpaste: "/static/skins/powerpaste/plugin.js"

        // 		},

        powerpaste_allow_local_images: true, //powerpaste允许黏贴
        // powerpaste_word_import: "clean", //powerpaste黏贴的样式获取方式
        paste_preprocess: function (pluginApi, data) {
          // 粘贴事件
          // console.log("粘贴pluginApi",pluginApi);
          // console.log("粘贴paste_preprocess",data.content);
          // console.log("粘贴------",_this)

          // setTimeout(()=>{
          // 	_this.inspectWdContent()
          // },1000)
          _this.$nextTick(() => {
            _this.inspectWdContent();
          });
        },
      },
      initData: {},
      // 富文本结束

      search_button_loading: false,
      img_search_loading: false, // 图库的加载

      r_editor: "",
      bookObj: {},

      r_name: null,
      r_channel_id: undefined,

      contentData: [
        // 本地图文模板数据
        {
          for_id: 111, // 用于for循环的id，因为要删除，然后不指定唯一id的话，会报错，不能用索引，会乱
          build_qrcode: "1", // 生成二维码，1=自动生成
          spread_name: "", // 推广链接名称
          spread_type: 1, // 推广链接类型，0=外推，1=内推
          read_type: 1, // 阅读类型，1=继续阅读，2=历史记录
          message_title: "", // 微信图文标题
          message_auth: "", // 微信图文作者
          message_content: "<p><br></p>", // 正文。<p><br></p>这是默认值，得用html标签的形式，不能用""或null之类的
          message_cover: "", // 封面
          message_foot_img: "", // 图文底图
          miniprogram_imageurl: "", //小程序封面图
          miniprogram_title: "", //小程序标题
          message_continue_read: "", // 继续阅读底图
          spread_book_id: null, // 推广书籍第三方id：read_type=1必传
          spread_chapter_id: null, // 推广书籍章节：read_type=1必传
          select_status: true, // 选中状态,true为选中,false为不选中
          message_show_foot_img: "", // 用于显示的二维码底图
        },
      ],
      content_index: 0, // 第几个素材的索引

      img_visible: false, // 图库弹窗
      img_confirmLoading: false,
      img_type: "1", // 1为选择封面。2为选择二维码底图。3为选择阅读原文提示图片
      img_page: 1, // 图库弹窗里的分页
      img_limit: 9, // 一页多少条
      show_img_total: 0, // 用于弹窗显示的总数
      ewm_total: 0, // 总数
      ewmImgData: [], // 二维码底图
      fmImgData: [], // 封面图
      ydywData: [], // 阅读原文提示图
      xcmfmData: [], //小程序封面图
      ewm_select_img_url: "", // 图库里选中的二维码底图
      ewm_show_img_url: "", // 图库里选中的二维码底图-用于显示
      fm_select_img_url: "", // 图库里选中的图片
      ydyw_select_img_url: "", // 图库里选中的阅读原文提示图
      xcxfm_select_img_url: "", //
      headers_token: "", // 图片上传用的token

      page_title: "新建", // 标题。新建or编辑
      r_edit_id: null, // 用于编辑的id
      editIdData: [], // 获取详情里的id。

      // 解析url
      url_visible: false,
      url_confirmLoading: false,
      r_url: "", // 填入的解析的url

      channel_parent: "", // 父类渠道

      title_select_control: false, // 标题的历史标题下拉框控制
      titleSelectData: [],

      cut_visible: false, // 裁切图片
      cut_confirmLoading: false, // 裁切图片弹窗确认按钮加载状态
      cut_img: "", // 要裁切的图片
      cor_option: {
        img: "https://oss.gzlize.com/gzh-local-message-material/amtyYtZR3wfDD4NL8E9Ee5vt32DU4Fhteq9Ka5uX.jpg",
        // img: 'https://avatars2.githubusercontent.com/u/15681693?s=460&v=4',
        size: 0.1,
        full: false,
        outputType: "jpeg",
        canMove: false,
        fixedBox: false,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 160,
        autoCropHeight: 150,
        centerBox: true, // 截图框是否被限制在图片里面
        high: true,
        max: 99999,
      },
      show: true,
      fixed: true,
      fixedNumber: [23.47, 10],
      cropper_width: 0,
      cropper_height: 0,
      cropper_w_h: 1, // 原图与实际图的比值
      cropper_original_img_url: "", // 要进行裁切的原图链接
      // fun: (a:string)=>number,
      mousedownFun: null, // 标题的下拉框控制函数

      add_confirm_destroy: null,
    };
  },
  mounted() {
    let that = this;

    _this = this; // 这里得保存个this给富文本的粘贴事件用

    // console.log(this.$route.query)
    var mouseDownFnc = function (e) {
      // console.log("mousedown",e);
      // 获取被点击的元素
      const clickedEl = e.target;

      // `el` 是你正在检测外部点击的元素
      if (
        document.getElementById("title-select-mousedown").contains(clickedEl)
      ) {
        // 单击“el”内部
        // console.log("单击“el”内部");
      } else {
        // 在`el`之外点击
        // console.log("在`el`之外点击");
        that.title_select_control = false;
      }
    };
    that.mousedownFun = mouseDownFnc;
    // 用于标题的下拉框控制
    window.addEventListener("mousedown", mouseDownFnc);

    // 富文本
    tinymce.init({});
    // 图片上传用的token
    this.headers_token = "Bearer " + localStorage.getItem("access_token");

    // 把这里写到外面来是为了，后面 自动保存数据的判断，得先判断是新建还是编辑
    if (that.$route.query.edit_id) {
      that.r_edit_id = that.$route.query.edit_id;
      that.page_title = "编辑";
    }

    materialSelectChannel({
      support_create_message: 1, // 是否支持新建本地图文模板0=否，1=是
    }).then((res) => {
      if (res.data.code == 0 || res.data.code == 200 || res.data.code == 8011) {
        that.bookObj = res.data.data.channel;

        if (that.$route.query) {
          // 编辑
          if (that.$route.query.edit_id) {
            // that.r_edit_id = that.$route.query.edit_id
            // that.page_title = "编辑"
            that.search_button_loading = true;
            materialInfo({
              id: that.$route.query.edit_id,
            }).then((res) => {
              that.search_button_loading = false;
              that.r_name = res.data.data.info.name;
              that.r_type = res.data.data.info.type || 1;
              that.r_channel_id = res.data.data.info.channel_id.toString();
              let data = res.data.data.info.message;
              data.forEach((res) => {
                res.message_show_foot_img =
                  "https://wx-admin.test.gzlize.com/qrcode-back" +
                  res.message_foot_img;
                res.select_status = false;
              });
              data[0].select_status = true;
              that.contentData = data;

              // 根据渠道ID获取对应的父类渠道的名字
              for (let key in that.bookObj) {
                if (key == that.r_channel_id) {
                  that.channel_parent =
                    that.bookObj[key] && that.bookObj[key].parent_name;
                }
              }
            });
          }
          // 新建
          else if (that.$route.query.chal_id) {
            // 列表页的新增过来会带上渠道id。
            // console.log("that.$route.query.chal_id",that.$route.query.chal_id);
            that.r_channel_id = that.$route.query.chal_id;
            // 根据渠道ID获取对应的父类渠道的名字
            for (let key in that.bookObj) {
              if (key == that.r_channel_id) {
                that.channel_parent = that.bookObj[key].parent_name;
              }
            }
          }
        }
      } else {
        if (res.data.code == 401) {
          // 未登录
          that.loginErr(res.data.msg || "未登录");
        } else {
          that.$message.error(`错误：${res.data.msg}`);
        }
      }
    });

    if (this.page_title != "编辑") {
      // if(this.page_title == '新建'){
      if (localStorage.getItem("materialStorage")) {
        that.add_confirm_destroy = this.$confirm({
          title: "检测到有保存的内容，是否恢复?",
          content: (h) => (
            <div style="">点击确定按钮就可以恢复上次自动保存的数据</div>
          ),
          onOk() {
            let data = JSON.parse(localStorage.getItem("materialStorage"));
            if (data.name) {
              that.r_name = data.name;
            }
            if (data.channel_id) {
              that.r_channel_id = data.channel_id;
              that.channel_parent = that.bookObj[data.channel_id].parent_name;
            }
            // 默认第一个显示和高亮
            data.content.forEach((res) => {
              res.select_status = false;
            });
            data.content[0].select_status = true;
            that.content_index = 0;
            that.contentData = data.content;
            that.r_type = Number(localStorage.getItem("localStorageType"));
          },
          onCancel() {
            console.log("Cancel");
          },
          class: "test",
        });
      }
    }
  },
  beforeDestroy() {
    // 在组件生命周期结束的时候销毁。
    let that = this;
    window.removeEventListener("mousedown", that.mousedownFun);
    if (that.page_title == "新建") {
      // 页面销毁时，把这个弹窗关闭掉
      that.add_confirm_destroy.destroy();
    }
  },
  watch: {
    contentData: {
      deep: true,
      // immediate: true,
      handler() {
        this.setLocalStorage();
      },
    },
    r_type(val) {
      localStorage.setItem("localStorageType", val);
    },
    channel_parent(newval) {
      const list = [2, 3];
      if (newval !== "乐读" && list.includes(this.r_type)) {
        this.r_type = 1;
      }
    },
  },
  computed: {
    readTypePlus() {
      const { r_channel_id, bookObj } = this;
      const itemParentName =
        bookObj[r_channel_id] && bookObj[r_channel_id].parent_name;
      return ["乐读", "享读"].includes(itemParentName);
    },
    // 展示小程序卡片信息
    calcShowMiniCard() {
      return this.r_type !== 1;
    },
    // 展示H5信息
    calcShowH5() {
      return this.r_type !== 3;
    },
    calcIsLedu() {
      return this.channel_parent === "乐读";
    },
  },
  methods: {
    cutClick(url) {
      this.$refs.getCropperImg.cutImgHandle(url, [1080, 864]);
    },
    cropperOk(img) {
      this.contentData[this.content_index].miniprogram_imageurl = img;
      this.$refs.getCropperImg.cutHandleCancel();
    },
    customPaste(editor, event, callback) {
      // JS 语法
      // event 是 ClipboardEvent 类型，可以拿到粘贴的数据
      // 可参考 https://developer.mozilla.org/zh-CN/docs/Web/API/ClipboardEvent
      const htmls = event.clipboardData.getData("text/html"); // 获取粘贴的 html
      this.contentData[this.content_index].message_content = htmls;
      // 阻止默认的粘贴行为
      event.preventDefault();
      callback(false); // 返回值（注意，vue 事件的返回值，不能用 return）
    },
    // 给ant design的select选择器重新设置定位
    getsPopupContainer(triggerNode) {
      return triggerNode.parentNode || document.body;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },

    // 富文本开始

    // 富文本结束

    handleChangeF(e) {
      this.r_channel_id = e;
      this.contentData.forEach((v) => (v.read_type = 1));
      if (e) {
        // 父类渠道
        this.channel_parent = this.bookObj[e].parent_name;
      } else {
        this.channel_parent = "";
      }

      // 保存一下
      this.setLocalStorage();
    },
    radioChangeA(e) {
      // 自动生成 或 手动生成
    },
    radioChangeB(e) {
      // 内推链接 或 外推链接
      this.contentData[this.content_index].spread_type = e.target.value;
    },
    handleChangeB(e) {
      // 阅读类型
      this.contentData[this.content_index].read_type = e;
      if (e !== 1) {
        this.contentData[this.content_index].spread_book_id = undefined;
        this.contentData[this.content_index].spread_chapter_id = undefined;
      }
    },
    changeEditorS(e) {
      // 富文本的值
    },
    // 切换显示的内容
    changeMaterial(e, index) {
      this.contentData.forEach((res) => {
        res.select_status = false;
      });
      this.contentData[index].select_status = true;
      this.content_index = index;

      // 纯文本处理
      this.inspectWdContent();
    },
    // 新建素材
    addContent() {
      let obj = {
        build_qrcode: "1", // 生成二维码，1=自动生成
        spread_name: "", // 推广链接名称
        spread_type: 1, // 推广链接类型，0=外推，1=内推
        read_type: 1, // 阅读类型，1=继续阅读，2=历史记录
        message_title: "", // 微信图文标题
        message_auth: "", // 微信图文作者
        message_content: "<p><br></p>", // 正文。<p><br></p>这是默认值，得用html标签的形式，不能用""或null之类的
        message_cover: "", // 封面
        message_foot_img: "", // 图文底图
        message_continue_read: "", // 继续阅读底图
        miniprogram_imageurl: "", //小程序封面图
        miniprogram_title: "", //小程序标题
        spread_book_id: null, // 推广书籍第三方id：read_type=1必传
        spread_chapter_id: null, // 推广书籍章节：read_type=1必传
        select_status: false, // 选中状态,true为选中,false为不选中
        message_show_foot_img: "", // 用于显示的二维码底图
      };
      obj.for_id = new Date().getTime(); // 利用时间戳来当成唯一id
      this.contentData.push(obj);
    },

    // 左边的素材进行排序
    sortIconButton(e, index) {
      let arr = this.contentData;
      arr.forEach((res, index) => {
        res.sss = index;
      });
      if (this.contentData.length > 1) {
        if (e == 1) {
          // 往上排序
          if (index > 0) {
            // 不能是第一个
            arr[index - 1].sss = arr[index - 1].sss + 1; // +1后数字变大了，就是往后排
            arr[index].sss = arr[index].sss - 1; // -1后数字变小了就是往前排

            arr.sort(function (a, b) {
              return a.sss - b.sss;
            });
          }
        } else if (e == 2) {
          // 向下排序
          if (index < this.contentData.length - 1) {
            // 不能是最后一个
            arr[index + 1].sss = arr[index + 1].sss - 1;
            arr[index].sss = arr[index].sss + 1;

            arr.sort(function (a, b) {
              return a.sss - b.sss;
            });
          }
        }
      }
    },
    // 删除图文-确认按钮
    confirmDelImg(index) {
      if (this.contentData.length > 1) {
        if (this.contentData[index].select_status) {
          // 为选中状态就不能直接删，因为页面正在显示当前选中的数据
          this.contentData[index].select_status = false;
          if (index == 0) {
            // 表示删除第一个
            this.content_index = 0;
            this.contentData[index + 1].select_status = true;
          } else if (index == this.contentData.length - 1) {
            // 删最后一个
            this.content_index = index - 1;
            this.contentData[index - 1].select_status = true;
          } else {
            this.content_index = index - 1;
            this.contentData[index - 1].select_status = true;
          }
        }

        this.contentData.splice(index, 1);
      } else {
        this.$message.warning("不能全部删除");
      }
    },
    // 删除图文-取消按钮
    cancelDelImg(index) {},

    // 获取图库素材
    getImgRequest(e) {
      // 获取要选择的素材
      let that = this;
      this.img_search_loading = true;
      if (e == 1) {
        // 选择封面
        materialLocalMessage({
          // 1=历史标题，2=封面图，3=微信二维码底图，4=继续阅读底图
          type: 2,
          page: that.img_page,
          limit: that.img_limit,
        }).then((res) => {
          that.img_search_loading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            let data = res.data.data.data;
            data.forEach((res) => {
              res.select_img = false;
            });
            that.fmImgData = res.data.data.data;
            that.show_img_total = res.data.data.total;
          } else {
            if (res.data.code == 401) {
              // 未登录
              that.loginErr(res.data.msg || "未登录");
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          }
        });
      } else if (e == 2) {
        // 二维码图片
        materialLocalMessage({
          // 1=历史标题，2=封面图，3=微信二维码底图，4=继续阅读底图
          type: 3,
          page: that.img_page,
          limit: that.img_limit,
        }).then((res) => {
          that.img_search_loading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            let data = res.data.data.data;
            data.forEach((res) => {
              res.select_img = false;
            });
            that.ewmImgData = res.data.data.data;
            that.show_img_total = res.data.data.total;
          } else {
            if (res.data.code == 401) {
              // 未登录
              that.loginErr(res.data.msg || "未登录");
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          }
        });
      } else if (e == 3) {
        // 阅读原文提示图
        materialLocalMessage({
          // 1=历史标题，2=封面图，3=微信二维码底图，4=继续阅读底图
          type: 4,
          page: that.img_page,
          limit: that.img_limit,
        }).then((res) => {
          that.img_search_loading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            let data = res.data.data.data;
            data.forEach((res) => {
              res.select_img = false;
            });
            that.ydywData = res.data.data.data;
            that.show_img_total = res.data.data.total;
          } else {
            if (res.data.code == 401) {
              // 未登录
              that.loginErr(res.data.msg || "未登录");
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          }
        });
      } else if (e == 4) {
        // 阅读原文提示图
        materialLocalMessage({
          // 1=历史标题，2=封面图，3=微信二维码底图，4=继续阅读底图  6=小程序封面图
          type: 6,
          page: that.img_page,
          limit: that.img_limit,
        }).then((res) => {
          that.img_search_loading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            let data = res.data.data.data;
            data.forEach((res) => {
              res.select_img = false;
            });
            that.xcmfmData = res.data.data.data;
            that.show_img_total = res.data.data.total;
          } else {
            if (res.data.code == 401) {
              // 未登录
              that.loginErr(res.data.msg || "未登录");
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          }
        });
      }
    },
    // 显示图库弹窗
    selectImg(e) {
      this.img_type = e;
      // 获取图库素材
      this.getImgRequest(e);
      this.img_visible = true;
    },
    // 图库弹窗确认
    imgHandleOk() {
      let that = this;
      if (that.img_type == 1) {
        // 选择封面
        this.contentData[this.content_index].message_cover =
          that.fm_select_img_url;
      } else if (that.img_type == 2) {
        // 选择二维码底图
        this.contentData[this.content_index].message_foot_img =
          that.ewm_select_img_url;
        this.contentData[this.content_index].message_show_foot_img =
          that.ewm_show_img_url;
      } else if (that.img_type == 3) {
        // 选择阅读原文提示图片
        this.contentData[this.content_index].message_continue_read =
          that.ydyw_select_img_url;
      } else if (that.img_type == 4) {
        // 小程序封面图
        this.contentData[this.content_index].miniprogram_imageurl =
          that.xcxfm_select_img_url;
      }
      that.imgHandleCancel();
    },
    // 取消
    imgHandleCancel() {
      this.img_visible = false;
    },
    // 图库类型切换选择
    imgCallback(e) {
      this.img_type = e;
      this.img_page = 1;
      // 获取图库素材
      this.getImgRequest(e);
    },
    // 选择二维码图片
    clickEwmImg(index) {
      let that = this;
      that.ewmImgData.forEach((res) => {
        res.select_img = false;
      });
      that.ewmImgData[index].select_img = true;
      // console.log(that.ewmImgData[index]);
      that.ewm_show_img_url = that.ewmImgData[index].content;
      that.ewm_select_img_url = that.ewmImgData[index].origin_content; // 图片链接
    },
    // 选择封面图片
    clickFmImg(index) {
      let that = this;
      that.fmImgData.forEach((res) => {
        res.select_img = false;
      });
      that.fmImgData[index].select_img = true;
      that.fm_select_img_url = that.fmImgData[index].content; // 图片链接
    },
    // 选择阅读原文提示图
    clickYdywImg(index) {
      let that = this;
      that.ydywData.forEach((res) => {
        res.select_img = false;
      });
      that.ydywData[index].select_img = true;
      that.ydyw_select_img_url = that.ydywData[index].content; // 图片链接
    },
    // 小程序封面
    clickXcxfmImg(index) {
      let that = this;
      that.xcmfmData.forEach((res) => {
        res.select_img = false;
      });
      that.xcmfmData[index].select_img = true;
      that.xcxfm_select_img_url = that.xcmfmData[index].content; // 图片链接
    },
    // 图库分页的切换
    imgPagingChange(e) {
      this.img_page = e;
      // 获取图库素材
      this.getImgRequest(this.img_type);
    },
    // 顶部图片上传 限制用户上传的图片格式和大小。
    beforeUpload(file) {
      console.log("beforeUpload", file);
      this.img_search_loading = true;

      const isJpgOrPng =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif";
      if (!isJpgOrPng) {
        this.img_search_loading = false;
        this.$message.error("图片格式只能为：PNG、JPEG、JPG/GIF");
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.img_search_loading = false;
        this.$message.error("图片大小不能超过10MB!");
      }
      return isJpgOrPng && isLt2M;
    },
    uploadChange(info) {
      console.log("图片请求", info);
      let that = this;

      if (info.file.status === "uploading") {
        this.img_search_loading = true;
        return;
      }
      if (info.file.status === "done") {
        console.log("图片请求done", info);
        if (info.file.response) {
          // 图片上传成功，有内容返回

          // this.img_search_loading = false

          // that.loading = false
          // if(that.img_type == '1'){ // 选择封面
          that.getImgRequest(that.img_type);
          // }
          // else if(that.img_type == '2'){ // 选择二维码底图

          // }
          // else if(that.img_type == '3'){ // 选择阅读原文提示图片

          // }
        } else {
          this.img_search_loading = false;
          this.$message.error(`错误：图片上传失败`);
        }
      }

      if (info.file.status === "error") {
        // 上传失败

        this.loading = false;
        this.$message.error(`错误：图片上传失败`);
      }
    },

    // 确认按钮
    addRequest() {
      let that = this;
      // let data = that.contentData;
      // console.log("检查内容是否都填",data);
      let reg = /<img/gi; // 后面有用到，不能注释
      // ,"<img data-ratio='1' "
      if (!that.r_name) {
        that.$message.warning("请填写模板标题");
      } else if (!that.r_channel_id) {
        that.$message.warning("请选择书城");
      } else {
        // 检查内容是否都填
        let data = that.contentData;
        for (let i = 0; i < that.contentData.length; i++) {
          if (!data[i].message_title) {
            that.$message.warning("请输入文章标题");
            return;
          } else if (!data[i].message_cover) {
            that.$message.warning("请选择封面");
            return;
          } else if (
            !data[i].message_content ||
            data[i].message_content == "<p><br></p>"
          ) {
            that.$message.warning("请输入正文");
            return;
          } else if (!data[i].message_foot_img && that.r_type !== 3) {
            that.$message.warning("请选择二维码底图");
            return;
          } else if (!data[i].message_continue_read && that.r_type !== 3) {
            that.$message.warning("请选择 阅读原文 提示");
            return;
          } else if (!data[i].spread_name) {
            that.$message.warning("请设置推广链接名称");
            return;
          } else if (!data[i].read_type) {
            that.$message.warning("请选择阅读类型");
            return;
          } else if (data[i].read_type === 1 && !data[i].spread_chapter_id) {
            that.$message.warning("请填写 继续阅读第几章");
            return;
          } else if (
            data[i].read_type === 1 &&
            !data[i].spread_book_id &&
            (that.channel_parent == "乐读" ||
              that.channel_parent == "常读" ||
              that.channel_parent == "掌读" ||
              that.channel_parent == "追书云" ||
              that.channel_parent == "文鼎" ||
              that.channel_parent == "万读" ||
              that.channel_parent.indexOf("阳光") > -1 ||
              that.channel_parent.indexOf("阅文") > -1 ||
              that.channel_parent.indexOf("花生") > -1)
          ) {
            that.$message.warning("请填写作品ID");
            return;
          }

          // 掌中云、迈步：只需要填写章节ID，作品ID不用显示，传0就可
          if (
            // that.channel_parent.indexOf("迈步") > -1 ||
            that.channel_parent.indexOf("掌中") > -1
          ) {
            that.contentData[i].spread_book_id = 0;
          }

          // 对正文的图片进行处理

          data[i].message_content = data[i].message_content.replace(
            reg,
            "<img data-ratio='1' "
          );

          // 20221221,这里是因为运营那边从135编辑复制图片过来，里面会有<br>，但是这个富文本给过滤掉了，所以这里给加上，避免在手机上看背景图，尺寸变小，因为需要<br>来给背景图撑高度
          data[i].message_content = data[i].message_content.replace(
            /align=\"center\"><\/p>/gi,
            `align="center"><br></p>`
          );
          // console.log("match",data[i].message_content.match(/align=\"center\"><\/p>/gi))
        }

        if (that.contentData.length == 1) {
          // 表示只有一个素材，可能没有进行切换，就没有对纯文本进行处理，所以这里再处理一下
          that.inspectWdContent();
        }
        if (that.r_type !== 1) {
          if (!this.contentData[this.content_index].miniprogram_title) {
            that.$message.warning("请填写小程序标题");
            return;
          }
          if (!this.contentData[this.content_index].miniprogram_imageurl) {
            that.$message.warning("请选择小程序图片");
            return;
          }
        }
        const temp = JSON.parse(JSON.stringify(that.contentData));
        if (this.r_type === 3) {
          for (let index = 0; index < temp.length; index += 1) {
            delete temp[index].message_foot_img;
            delete temp[index].message_show_foot_img;
          }
        }
        that.contentData = temp;
        // 发送请求
        that.search_button_loading = true;
        if (that.page_title == "新建") {
          materialAdd({
            name: that.r_name, // 图文模板
            channel_id: that.r_channel_id, // 选择书城
            content: that.contentData, // 内容
            type: that.r_type,
          }).then((res) => {
            // console.log("新增", res);
            that.search_button_loading = false;
            if (
              res.data.code == 0 ||
              res.data.code == 200 ||
              res.data.code == 8011
            ) {
              that.$message.success("添加成功");

              // 清空保存的缓存
              localStorage.setItem("materialStorage", "");
              localStorage.setItem("localStorageType", "");
              setTimeout((res) => {
                that.cancelButton();
              }, 800);
            } else {
              if (res.data.code == 401) {
                // 未登录
                that.loginErr(res.data.msg || "未登录");
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          });
        } else if (that.page_title == "编辑") {
          let data = that.contentData;
          data.forEach((res) => {
            // 检查是否有新增素材或删除素材
            // console.log("res.hasOwnProperty('id')",res.hasOwnProperty('id'));
            if (!res.hasOwnProperty("id")) {
              res.id = 0;
            }
          });
          console.log(`编辑模板类型:${that.r_type}`);
          materialEdit({
            id: that.r_edit_id, // 编辑的id
            name: that.r_name, // 图文模板
            channel_id: that.r_channel_id, // 选择书城
            content: that.contentData, // 内容
            type: that.r_type,
          }).then((res) => {
            that.search_button_loading = false;
            if (
              res.data.code == 0 ||
              res.data.code == 200 ||
              res.data.code == 8011
            ) {
              that.$message.success("编辑成功");

              // 清空保存的缓存
              localStorage.setItem("materialStorage", "");
              localStorage.setItem("localStorageType", "");
              setTimeout((res) => {
                that.cancelButton();
              }, 800);
            } else {
              if (res.data.code == 401) {
                // 未登录
                that.loginErr(res.data.msg || "未登录");
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          });
        }
      }
    },
    // 取消按钮
    cancelButton() {
      // this.$router.replace({ name: "materialList_", params: {} });
      const { href } = this.$router.resolve("/materialList");
      window.open(href, "_blank");
    },

    // 解析url
    resolveUrl() {
      if (!this.r_channel_id) {
        this.$message.warning("请选择书城");
      } else {
        this.url_visible = true;
      }
    },
    urlHandleOk() {
      let that = this;
      this.url_confirmLoading = true;
      materialCodeUrl({
        channel_id: this.r_channel_id,
        url: this.r_url,
      }).then((res) => {
        that.url_confirmLoading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.contentData[that.content_index].spread_book_id =
            res.data.data.spread_book_id;
          that.contentData[that.content_index].spread_chapter_id =
            res.data.data.spread_chapter_id;

          that.urlHandleCancel();
          that.$message.success("解析成功");
        } else {
          if (res.data.code == 401) {
            // 未登录
            that.loginErr(res.data.msg || "未登录");
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    urlHandleCancel() {
      this.r_url = "";
      this.url_confirmLoading = false;
      this.url_visible = false;
    },

    goPage(type) {
      if (type == 1) {
        // 运营书城渠道
        const { href } = this.$router.resolve("/operateChannel");
        window.open(href, "_blank");
      }
    },

    // 标题输入框的相关事件
    titleInputChange(e) {
      // 变化
      let that = this;
      materialLocalMessage({
        type: 1,
        name: e.target.value,
      }).then((res) => {
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.title_select_control = true;
          that.titleSelectData = res.data.data.data;
        } else {
          if (res.data.code == 401) {
            // 未登录
            that.loginErr(res.data.msg || "未登录");
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    titleInputFocus(e) {
      // 获取焦点
      // console.log("获取焦点",e);
    },
    titleInputBlur(e) {
      // 失去焦点
      // console.log("失去焦点",e);
      // this.title_select_control = false
    },
    // 选中某一个历史下拉框里的内容
    selectTitleCell(item) {
      console.log("item", item);
      this.contentData[this.content_index].message_title = item.content;
      this.title_select_control = false;
    },

    // 裁切图片
    cutCover() {
      let that = this;
      // 第一个素材的封面图张条形，第二个以及以后的素材是正方形
      if (that.content_index == 0) {
        // 第一个素材
        this.fixedNumber = [23.47, 10];
      } else {
        // 第二个以及以后的素材
        this.fixedNumber = [10, 10];
      }

      // 因为这个图片裁切其实是传递不同的参数给阿里云来显示图片，所以每次显示裁切图都要把后面的参数去掉
      let o_data =
        this.contentData[this.content_index].message_cover.split("?");
      this.cor_option.img = o_data[0];

      var img = new Image();
      img.src = this.cor_option.img;
      img.onerror = function () {
        alert(name + " 图片加载失败，请检查url是否正确");
        return false;
      };

      function img_ifo() {
        if (img.width >= img.height) {
          // 长图
          if (img.width < 500) {
            // 实际图片小于显示图片尺寸
            // 这里有一点要处理，是否要进行放大，目前是没有放大
            that.cropper_width = img.width;
            that.cropper_height = img.height;
          } else {
            // 实际图片大于等于显示图片尺寸
            that.cropper_width = 500;
            that.cropper_height = that.cropper_width * (img.height / img.width);
          }
          that.cropper_w_h = 500 / img.width;
        } else if (img.width == img.height) {
          // 正方形图
          that.cropper_width = 500;
          that.cropper_height = 500;
          that.cropper_w_h = 1;
        } else {
          // 高图
          if (img.width < 300) {
            // 图片小于显示宽高时
            // console.log(1111)
            that.cropper_width = img.width;
            that.cropper_height = img.height;
          } else {
            // 图片大于等于显示宽高时
            // console.log(2222)
            that.cropper_width = 300;
            that.cropper_height = that.cropper_width * (img.height / img.width);
          }
          that.cropper_w_h = 300 / img.width;
        }

        that.cut_visible = true;
      }

      if (img.complete) {
        console.log("1", img.width + " " + img.height);
        console.log("1", img.width, img.height);

        img_ifo();
      } else {
        img.onload = function () {
          console.log("2", img.width + " " + img.height);
          img.onload = null; //避免重复加载

          img_ifo();
        };
      }
    },
    cutHandleOk() {
      let that = this;
      // x2-x1的值为裁切框的宽
      // y2-y1得出的值是裁切框的高
      // x1，y1则是X，Y坐标的起始点
      // console.log("获取坐标",this.$refs.cropper.getCropAxis())
      let data = this.$refs.cropper.getCropAxis();
      let w = Math.round(data.x2 - data.x1);
      let h = Math.round(data.y2 - data.y1);
      let x = Math.round(data.x1);
      let y = Math.round(data.y1);
      // console.log("that.cropper_w_h",that.cropper_w_h)
      let s_w = Math.round(w / that.cropper_w_h);
      let s_h = Math.round(h / that.cropper_w_h);
      let s_x = Math.round(x / that.cropper_w_h);
      let s_y = Math.round(y / that.cropper_w_h);

      // console.log("实际坐标w",s_w)
      // console.log("实际坐标h",s_h)
      // console.log("实际坐标x",s_x)
      // console.log("实际坐标y",s_y)
      let oss_text = `?x-oss-process=image/crop,x_${s_x},y_${s_y},w_${s_w},h_${s_h}`;
      // console.log("oss_texty",oss_text)
      // console.log("this.cor_option.img",this.cor_option.img.split('?'))
      let img_data = this.cor_option.img.split("?"); // 把图片链接后面的参数去掉
      // 这里需要再做一个处理，当图片链接本身就有这些x,y,w,h参数时，要进行去除
      this.contentData[this.content_index].message_cover =
        img_data[0] + oss_text;

      this.cut_visible = false;
    },
    cutHandleCancel() {
      this.cut_visible = false;
    },

    // 保存。每编辑一次保存一次
    setLocalStorage() {
      if (this.page_title == "新建") {
        localStorage.setItem("localStorageType", this.r_type);
        localStorage.setItem(
          "materialStorage",
          JSON.stringify({
            name: this.r_name, // 图文模板
            channel_id: this.r_channel_id, // 选择书城
            content: this.contentData, // 内容
          })
        );
      }
    },
    // 模板标题输入框
    nameBlur() {
      // 保存一下
      this.setLocalStorage();
    },

    // 插入链接
    editorButton(type) {
      let that = this;
      if (type == 1) {
        // 插入链接
        that.$refs.getInsertLink.showModal();
      } else if (type == 2) {
        that.$refs.getXcxLink.showModal();
      }
    },
    insertLinkHandle(link_url, link_txt) {
      var ed = tinymce.get("tinymce");
      var range = ed.selection.getRng();

      // 创建要插入的内容
      var divNode = ed.getDoc().createElement("p");

      // const realStr = `<a target="_blank" href="${link_url}" textvalue="ceshilianjiebiaoti" linktype="text"
      // 				imgurl tab="outerlink" style="font-size: 20px;" title="${link_url}">
      // 					<span style="font-size: 20px;">
      // 						${link_txt}
      // 					</span>
      // 				</a>
      // 				<br>`;
      // divNode.style.textAlign = "center"

      const realStr = `
				<p style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; clear: both; min-height: 1em; font-size: 17px; letter-spacing: 0.544px; background-color: rgb(255, 255, 255); color: rgb(51, 51, 51); font-family: -apple-system, BlinkMacSystemFont, &quot;Helvetica Neue&quot;, &quot;PingFang SC&quot;, &quot;Hiragino Sans GB&quot;, &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;, Arial, sans-serif; text-align: center; box-sizing: border-box !important; overflow-wrap: break-word !important; visibility: visible;">
					<a href="${link_url}" style="visibility: visible;">
						
						<span style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; box-sizing: border-box !important; word-wrap: break-word !important; color: #ffffff; font-size: 32px; letter-spacing: 0.544px; background-color: #ff2941; visibility: visible; overflow-wrap: break-word !important;" data-darkmode-bgcolor-16158778700373="rgb(255, 41, 65)" data-darkmode-original-bgcolor-16158778700373="#fff|rgb(255, 41, 65)" data-darkmode-color-16158778700373="rgb(255, 255, 255)" data-darkmode-original-color-16158778700373="#fff|rgb(255, 255, 255)">
							<strong style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; line-height: 25.6px; box-sizing: border-box !important; overflow-wrap: break-word !important; visibility: visible;">
								<span style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; font-size: 12px; color: rgb(136, 136, 136); box-sizing: border-box !important; overflow-wrap: break-word !important; visibility: visible;">
									<span style="margin: 0px; padding: 0px; outline: 0px; max-width: 100%; box-sizing: border-box !important; word-wrap: break-word !important; color: #ffffff; font-size: 32px; letter-spacing: 0.544px; visibility: visible; overflow-wrap: break-word !important;" data-darkmode-bgcolor-16158778700373="rgb(255, 41, 65)" data-darkmode-original-bgcolor-16158778700373="#fff|rgb(255, 41, 65)" data-darkmode-color-16158778700373="rgb(255, 255, 255)" data-darkmode-original-color-16158778700373="#fff|rgb(255, 255, 255)">
										${link_txt}
									</span>
								</span>
							</strong>
						</span>
					</a>
				</p>
			`;

      divNode.innerHTML = realStr;

      range.insertNode(divNode);
    },

    // 插入小程序
    xcxModalOk(obj) {
      let that = this;
      console.log("插入小程序", obj);
      if (obj.show_type == 1) {
        // 文本
        var ed = tinymce.get("tinymce");
        var range = ed.selection.getRng();

        // 创建要插入的内容
        var divNode = ed.getDoc().createElement("p");
        const realStr = `
					<p style="text-align: center;">​
					<a class="weapp_text_link js_weapp_entry" style="font-size:17px;" data-miniprogram-appid="wxfe44ad89fae29b8d" data-miniprogram-path="pages/animation/animation" data-miniprogram-nickname="与你相遇的四月" href="" data-miniprogram-type="text" data-miniprogram-servicetype="">
					小程序文字测试1
					</a>
					</p>
				`;
        divNode.innerHTML = realStr;
        range.insertNode(divNode);
      } else if (obj.show_type == 2) {
        // 图片
      } else if (obj.show_type == 3) {
        // 小程序卡片
      }
    },

    // 万读那边复制过来的是纯文本，然后换行的效果就会被处理掉，现在是要想办法把换行加上
    inspectWdContent() {
      // 纯文本复制到富文本里，如果是有换行的话，切换不同的素材，再切换回来，换行就没有了，所以打算手动给里面加上<br/>标签
      let that = this;
      this.contentData.forEach((res, index) => {
        // console.log("res.message_content.indexOf('<br />')",res.message_content.indexOf('<br />'))
        // console.log("res.message_content.split('<p').length",res.message_content.split("<p").length)
        // console.log(index,"--------------------")
        // console.log(res.message_content)
        // console.log("a",res.message_content.split("<p").length <= 7)
        // console.log("a",res.message_content.indexOf('<br>') == -1)
        // console.log("a",res.message_content.indexOf('<br />') == -1)
        // console.log("a",res.message_content.indexOf('&ldquo;') > -1)
        // console.log("a",res.message_content.indexOf('&rdquo;') > -1 )
        // console.log("a",res.message_content.indexOf('<br> &ldquo;') == -1)
        // console.log("a",res.message_content.indexOf('&rdquo; <br>') == -1)
        // .split("<p").length有两个<p>那么出来的结果就是3，所以4就代表有3个<p>
        // 增加<p>的判断，因为万读那边手动纯文本复制过来只有1-2个<p>，但是迈步这种通过生成推广链接复制过来的文案就会有很多个<p>，那这种情况就不需要处理了
        // 135编辑器那边复制过来的会多带上几个<p>，所以这里的数值不能设置的太小
        if (
          res.message_content.split("<p").length <= 7 &&
          res.message_content.indexOf("<br>") == -1 &&
          res.message_content.indexOf("<br />") == -1 &&
          res.message_content.indexOf("&ldquo;") > -1 &&
          res.message_content.indexOf("&rdquo;") > -1 &&
          res.message_content.indexOf("<br> &ldquo;") == -1 &&
          res.message_content.indexOf("&rdquo; <br>") == -1
        ) {
          // 多加一个.indexOf('&ldquo;') > -1判断是为了把那些功能正常，但是不需要进行下面处理的内容也区别出去
          // console.log("index", index)
          // console.log("res.message_content",res.message_content)
          let ccc = JSON.parse(JSON.stringify(res.message_content));

          ccc = ccc.replace(/&ldquo;/gi, `<br> &ldquo;`);

          ccc = ccc.replace(/。 /gi, `。<br>`); // 句号后带空格的也要进行换行
          ccc = ccc.replace(/？ /gi, `？<br>`); // 问号后带空格的也要进行换行
          ccc = ccc.replace(/&rdquo;/gi, `&rdquo; <br>`);
          ccc = ccc.replace(/：<br> &ldquo;/gi, `：&ldquo;`);

          ccc = ccc.replace(/<br>。/gi, `。`); // 句号前面就不要换行了。会有这种 文字?"。的句式出现，所以这里要处理
          // let reg_a = new RegExp(`&rdquo; <br>。`, 'gi')
          // ccc = ccc.replace(reg_a, '&rdquo;。')

          ccc = ccc.replace(/><br>&ldquo;/gi, `>&ldquo;`);

          ccc = ccc.replace(/<br> <br>/gi, `<br>`);
          ccc = ccc.replace(/<br><br>/gi, `<br>`);
          // console.log("ccc",ccc)
          res.message_content = ccc;
        }
      });
    },

    // 未登录弹窗
    loginErr(msg) {
      // 清空登录状态，跳去登录页
      // localStorage.removeItem("access_token");
      // this.$router.replace({name: 'login',params: {type:'not_log'}})

      this.$error({
        title: `${msg}`,
        content:
          "如未登录，可另开一个标签页进行登录，此页面就会变成登录状态，就无需在此页面退出",
        okText: "去登录",
        onOk() {
          // window.open(`${that.$http.excel_url}api/adq/account-auth?id=1`)
          window.open("/", "_blank");
        },
      });
    },
  },
};
</script>

<style scoped>
@import url("./materialAdd.css");
</style>
